export default {
  getHead: () => {
    return [{name: '학교명'}, {name: '사업명'}, {name: '작업구분'}, {name: '점검일자'}, {name: '수검부서'}, {name: '점검부서'}, {name: '작성자'}, {name: '작성일'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).inputA_1_name
      case 1: return func.getContent(value).inputA_2
      case 2: return func.getContent(value).categoryLabel
      case 3: return func.getContent(value).inputA_3
      case 4: return func.getContent(value).inputA_8
      case 5: return func.getContent(value).inputA_5
      case 6: return func.getContent(value).stdInfo.writer_name
      case 7: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputA_3) {
      nav.dateTarget = 'content$body.inputA_3'
      nav.dateBegin = 'nav.value.inputA_3.sDate'
      nav.dateEnd = 'nav.value.inputA_3.eDate'
    }
    return {inputA_3: nav.value.inputA_3, categoryLabel: nav.value.categoryLabel}
  },
  getSearchKeyword: (nav) => {
    return ['content$body.categoryLabel*[:nav.page.p74.categoryLabel]']
  },
}
